import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { urlEndPoints } from '@shared/config/end-points';
import { Task, TasksPaginatedResponse } from '@shared/models/task.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TaskDal {
  constructor(private httpClient: HttpClient) {}

  getAllTasks(status: string, page: number, limit: number): Observable<TasksPaginatedResponse> {
    let endPoint = `${urlEndPoints.tasks}?page=${page}&limit=${limit}`;

    if (status) {
      endPoint += `&status=${status}`;
    }

    return this.httpClient.get<TasksPaginatedResponse>(endPoint);
  }

  retryTask(taskId: string): Observable<void> {
    return this.httpClient.patch<void>(`${urlEndPoints.tasks}/${taskId}/retry`, {});
  }

  cancelTask(taskId: string): Observable<Task> {
    return this.httpClient.patch<Task>(`${urlEndPoints.tasks}/${taskId}/cancel`, {});
  }
}
